import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useBetaWall } from "../../../../hooks/useBetaWall";
import { useUserContext } from "../../../../context/UserContext";
import { signInPath } from "../../../../route_paths";

/**
 * Layout route that keeps visitors without an account out of the pages it wraps while the beta
 * wall is up, sending them to sign in and back. With the wall down it renders the pages as is.
 */
export function BetaWallGate() {
  const wallUp = useBetaWall();
  const { session, loading } = useUserContext();
  const { pathname, search } = useLocation();

  if (!wallUp) return <Outlet />;
  if (loading) return null;
  const hasAccount = !!session && !session.user.is_anonymous;
  if (hasAccount) return <Outlet />;
  return <Navigate to={signInPath(`${pathname}${search}`)} replace />;
}
